/** Imports */
import { fork, put, takeLatest, takeEvery, all, select, call } from 'redux-saga/effects';
import {
  BUNDLE,
  UPDATEFOR, FLOW, formGenericStandardPhoneRequestBody, formStandaloneHSIRequestBody,
  formGenericDataRequestBodyBasedOnFlow, formDoubleDataBdvRequestBody, getRequestPayloadBasedOnBundleType, formDoublePhoneDATARequestBody,
  getSelectedBundleInfoBasedOnBundleType,
  formDoubleFlexDataVideoRequestBody, getNonDoBundlePlanBasedOnBundleType,
  formTripleSolutionBundleFiosRequestBody, formTripleDataBdvTvRequestBody,
  formDoublePhoneHSIRequestBody, formatTvPlanForBundle, getFlowToUpdate,
  formGenericVideoRequestBodyBasedOnFlow, REVERSE_BUNDLE, getBDVEquipments
} from './bundleConversionUtils';
import {
  GET_STANDARD_PHONE_URL,
  UPDATE_PHONE_URL,
  UPDATE_BDV_URL,
  GET_CART_INFO_URL,
  GET_FLOAT_CART_URL,
  GET_FIOS_TV_URL,
  UPDATE_FIOS_TV_URL,
  UPDATE_BASIC_INTERNET_DATA_URL,
  UPDATE_FIOS_INTERNET_DATA_URL,
  GET_SELECTED_BUNDLE_INFO_URL,
  GET_BASIC_INTERNET_DATA_URL,
  GET_SELECTED_BDV_BUNDLE_INFO_URL,
  GET_SELECTED_FLEX_BUNDLE_INFO_URL,
  POST_UPDATE_BUNDLE,
  POST_UPDATE_NON_BUNDLE
} from './APIurls';

import * as selectors from '../containers/selectors';
import * as floatSelectors from '../Common/FloatingCart/containers/selectors';

import { ERROR_MESSAGE } from './constants';
import apiClient from '../utils/apiClient';

import { loadFloatingCart } from '../Common/FloatingCart/containers/dynamicCartSaga';
import * as SiteAnalytics from '../sitecatalyst';
import * as ChatAnalytics from '../utils/lpchatMetrics';
import i18next from "i18next";
import { CheckAEMBoolValue } from '../Common/CommonPlanTile/CommonPlanTile';

/**Header Data */
const HeadersForFormData = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }
};

/** Test Mulit Bundle Saga */
function* getTestSaga() {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  try {
    // const response = yield apiClient.get(INITIATE_GLOBAL_SESSION_URL);
    // yield put({ type: "SAVE_GLOBAL_SESSION_VALUES", data: response.data });
    console.log('Multi Saga Called...');

  }
  catch (err) {
    console.log('Catch Error', err);
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
  }
}

/** Fetch DATA/INTERNET */
function* fetchInternetData(request) {
  // yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  let reqFrom = '', params = {}, neededParams = {};
  // if (request.reqFrom && request.reqFrom === BUNDLE.HSI_PHONE) {
  //   params = request.params;
  //   neededParams = request.neededParams;
  //   reqFrom = request.reqFrom;
  // } else {
  params = request.params;
  // }
  // const { params } = request;
  const response = yield apiClient.get(params.url)
    .then(response => response.data)
    .catch(error => ({ error }));

  if (params.type === 'data') {
    yield put({ type: "GET_INTERNET_FLOW_RES", data: response });
    yield put({ type: "GET_STANDALONE_INTERNET_FLOW_RES", data: response });
  } else {
    yield put({ type: "GET_INTERNET_FLOW_RES", data: response });
  }

  // Added for reset to rent router on bundle conversion
  const internet = yield select(selectors.internet);
  let { RouterSelection } = internet;
  if (internet?.RouterSelection && RouterSelection.NewID) {
    const selectedRouterFromAPI = response?.Routers.filter(router => router.IsSelected === true);
    const initialOldID = selectedRouterFromAPI[0] ? selectedRouterFromAPI[0].PrdID : '';
    RouterSelection.NewID = initialOldID;
    yield put({ type: "UPDATE_INTERNET_CART_SELECTION", data: { ...internet } });
  }

  //yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
}


export function* fetchFiosTv(reqparams) {
  if (!reqparams.ignoreSpinner) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  }
  const isBannerFlow = yield select(selectors.isBannerFlow);
  const isBundleOffersFlow = yield select(selectors.isBundleOffersFlow);
  const bannerInfo = yield select(selectors.bannerInfo);
  let bannerTVSelection = {};
  let { params, tvParams } = reqparams;
  const flowType = getFlowToUpdate(tvParams?.type ? tvParams?.type : '');
  try {
    const response = yield apiClient.get(GET_FIOS_TV_URL, reqparams)
      .then(response => {
        if (params && params.hasOwnProperty('filter2')) {
          bannerTVSelection = {};
        } else {
          const selectedDetails = response.data.Plans.filter(e => e.TVView === response.data.TVView &&
            e?.IsSelected === true);
          if (selectedDetails?.length !== 0) {
            bannerTVSelection = {
              TVView: response.data.TVView, selectedDetails: formatTvPlanForBundle(selectedDetails[0],
                response.data.TVView)
            };
          }
        }
        return response.data;
      });
    yield put({ type: "GET_FIOS_TV_RESPONSE", data: response });
    yield put({ type: "GET_STANDALONE_TV_FLOW_RES", data: response });
    // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  } catch (err) {
    console.log('Catch Error', err);
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
  }

}


/** Get Cart Info */
export function* getCartInfo() {

  const params = new URLSearchParams();
  params.append("type", "OC");
  params.append("SelectedDueDate", "");
  params.append("skipVo", "false");

  try {
    const response = yield apiClient.post(GET_CART_INFO_URL, params, HeadersForFormData);
    /* Commenting Below line is for local mock json pointing */
    //const response = yield apiClient.post('http://localhost:3001/getCartInfo', params)

    yield put({ type: "GET_CART_INFO_RESPONSE", data: response.data });
  }
  catch (err) {
    console.log('Catch Error', err);
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_PC_GETFLOATCART' });

  }
}


export function* getFloatingCartDetails(postSaveCart, fromEvent, lastVistFlag) {
  if (fromEvent === 'Retrieve') {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  }
  let isValidaGetCartResp = false;
  try {
    const response = yield apiClient.get(GET_FLOAT_CART_URL, undefined, HeadersForFormData);
    // const response = yield apiClient.get('http://localhost:3001/GetNonDoFlow');

    if (response.data?.planDetails) {
      isValidaGetCartResp = true;
    }
    if (fromEvent === 'Retrieve') {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      if (!lastVistFlag) {
        yield put({ type: "TOGGLE_CART_LOADING", data: false });
      }
    }
    yield put({ type: "FLOATING_CART_LOADING_SPINNER", data: false });
    const pendingOrderResponseInProgress = yield select(selectors.pendingOrderResponseInProgress);
    const chkAvailibtyClicked = yield select(selectors.chkAvailibtyClicked)
    if (!pendingOrderResponseInProgress) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
    if (!chkAvailibtyClicked) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
    yield put({ type: "GET_FLOAT_CART_RESPONSE", data: response.data });
    yield put({ type: "HAS_CHECKOUT_DETAILS_RESPONSE", data: "Y" });
    yield put({ type: "UPDATE_ADDITIONAL_CORDLESS", data: false });
    yield put({ type: "DISABLE_UPDATE_CORDLESS_BASE", data: false });
    yield put({ type: "UPDATE_IS_SAVED_CART_OFFER_APPLIED", data: response?.data?.planDetails?.isSavedCartOfferApplied });
    let setBaseCordlesAdded = false;
    let isAdditionalCordless = false;
    if (response.data?.planDetails?.equipmentAndOnetimeCharges && response.data.planDetails.equipmentAndOnetimeCharges?.length > 0) {
      for (var k = 0; k < response.data.planDetails.equipmentAndOnetimeCharges?.length; k++) {
        const cordlessAddedOfferName = response.data.planDetails.equipmentAndOnetimeCharges[k]?.offerName;
        setBaseCordlesAdded = cordlessAddedOfferName && cordlessAddedOfferName.indexOf('base') > -1;
        if (setBaseCordlesAdded) {
          yield put({ type: "UPDATE_ADDITIONAL_CORDLESS", data: true });
          return
        }
        const offername = response.data.planDetails.equipmentAndOnetimeCharges[k]?.offerName;
        isAdditionalCordless = offername && offername.indexOf('Additional') > -1;
        if (isAdditionalCordless) {
          yield put({ type: "DISABLE_UPDATE_CORDLESS_BASE", data: true });
        }
      }

    }

    yield put({ type: "HAS_CHECKOUT_DETAILS_RESPONSE", data: "Y" });

    if (fromEvent) {
      try {
        SiteAnalytics.trackCheckoutProdSelection(response.data);
      } catch (err) {
        console.log('trackCheckoutProdSelection - Catch Error', err);
      }
    }
    ChatAnalytics.setCartTracking(response.data);
    if (postSaveCart) {
      yield put({ type: "POST_SAVE_CART_INVALID", data: false });
      if (response.data?.HeaderInfo && response.data?.HeaderInfo?.Ftype == null) {
        yield put({ type: "POST_SAVE_CART_INVALID", data: true });
        const reterieveFlowtype = {
          flowType: ""
        }
      }
      else if (response.data?.planDetails?.HeaderInfo?.selectedService == "TV") {
        const params = {
          url: GET_FIOS_TV_URL
        }
        const reterieveFlowtype = {
          flowType: response.data.planDetails.HeaderInfo.selectedService
        }
        // yield put({ type: "GET_FIOS_TV_REQUEST", fetchFiosTv, params: params });

      }
      else if (response.data?.planDetails?.HeaderInfo?.selectedService === 'BDV') {
        const reterieveFlowtype = {
          flowType: response.data.planDetails.HeaderInfo.selectedService
        }
      }
      else if (response.data?.planDetails?.HeaderInfo?.selectedService === 'VOICE') {
        const reterieveFlowtype = {
          flowType: response.data.planDetails.HeaderInfo.selectedService
        }
      }

    }
    yield put({type:"IS_UPDATE_DONE",data:true})
  }
  catch (err) {
    console.log('getFloatingCartDetails - Catch Error', err);
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "FLOATING_CART_LOADING_SPINNER", data: false });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    if (!isValidaGetCartResp) {
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_PC_GETCARTDETAILS' });
    }
    yield put({type:"IS_UPDATE_DONE",data:false})
  }
}



export function* processFloatingCartDetails(response) {
  let isValidaGetCartResp = false;
  try {
    if (response?.planDetails) {
      isValidaGetCartResp = true;
    }
    const resetUpdateCartPageLoad = yield select(state=>state.CustomizeOrder.resetUpdateCartPageLoad)
    const pendingOrderResponseInProgress = yield select(selectors.pendingOrderResponseInProgress);
    const chkAvailibtyClicked = yield select(selectors.chkAvailibtyClicked)
    if (!pendingOrderResponseInProgress) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
    if (!chkAvailibtyClicked) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
    yield put({ type: "GET_FLOAT_CART_RESPONSE", data: response });
    // if(resetUpdateCartPageLoad) yield put({ type: "GET_FLOAT_CART_RESPONSE", data: response });
    // yield put({ type: "RESET_UPDATECART_ONPAGE_LOAD" });
    yield put({ type: "HAS_CHECKOUT_DETAILS_RESPONSE", data: "Y" });
    yield put({ type: "UPDATE_ADDITIONAL_CORDLESS", data: false });
    yield put({ type: "DISABLE_UPDATE_CORDLESS_BASE", data: false });
    yield put({ type: "UPDATE_IS_SAVED_CART_OFFER_APPLIED", data: response?.planDetails?.isSavedCartOfferApplied });
    let setBaseCordlesAdded = false;
    let isAdditionalCordless = false;
    if(response?.planDetails?.otherServices[0]?.Product?.includes('Rent'))
    {
      yield put({ type: "SET_ISROUTER_SELECTED", data: true });     
      
    }
    else{
      // yield put({ type: "SET_ISROUTER_SELECTED", data: false });    
    }
    if (response?.planDetails?.equipmentAndOnetimeCharges && response.planDetails.equipmentAndOnetimeCharges?.length > 0) {
      for (var k = 0; k < response.planDetails.equipmentAndOnetimeCharges?.length; k++) {
        const cordlessAddedOfferName = response.planDetails.equipmentAndOnetimeCharges[k]?.offerName;
        setBaseCordlesAdded = cordlessAddedOfferName && cordlessAddedOfferName.indexOf('base') > -1;
        if (setBaseCordlesAdded) {
          yield put({ type: "UPDATE_ADDITIONAL_CORDLESS", data: true });
          return;
        }
        const offername = response.planDetails.equipmentAndOnetimeCharges[k]?.offerName;
        isAdditionalCordless = offername && offername.indexOf('Additional') > -1;
        if (isAdditionalCordless) {
          yield put({ type: "DISABLE_UPDATE_CORDLESS_BASE", data: true });
        }
      }

    }
    if (response?.isSavedCartOfferApplied) {
      SiteAnalytics.trackFiosSavedCartOffers(response?.isSavedCartOfferApplied === "Y");
    }
    yield put({ type: "HAS_CHECKOUT_DETAILS_RESPONSE", data: "Y" });
    yield put({ type: "FLOATING_CART_LOADING_SPINNER", data: false });
    ChatAnalytics.setCartTracking(response);
  }
  catch (err) {
    console.log('getFloatingCartDetails - Catch Error', err);
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "FLOATING_CART_LOADING_SPINNER", data: false });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    if (!isValidaGetCartResp) {
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_PC_GETCARTDETAILS' });
    }
  }
  finally{
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

// used in new api
/** Get Selected Bundle Info For Standalone Data/Internet/TV */
export function* getSelectedBundleInfo(request, isLQCall = false) {
  const { params, infoParams } = request;
  const bannerInfo = yield select(selectors.bannerInfo);
  const LqData = yield select(selectors.LqData);
  let HSIStatus = LqData?.HSIStatus;
  //yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  if (infoParams.ptype === "DSL") {
    yield put({
      type: "UPDATE_ALL_SELECTED_NON_DO_BUNDLE_PLANS_INFO",
      params: { id: BUNDLE.HSI, selectedPlans: infoParams }
    });
    yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.HSI });

  } else {
    yield put({
      type: "UPDATE_ALL_SELECTED_NON_DO_BUNDLE_PLANS_INFO",
      params: { id: BUNDLE.DATA, selectedPlans: infoParams }
    });
    yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA });
  }

  const formParams = new URLSearchParams();

  Object.keys(infoParams).forEach(key => {
    formParams.append(key, infoParams[key]);
  });
  const addressQualificationDetails = yield select(selectors.addressQualificationDetails);
  if (addressQualificationDetails?.DefaultReg === "Y" && isLQCall && !bannerInfo) {
    if (params.type === 'data') {
      const addressQualificationDetails = yield select(selectors.addressQualificationDetails);
      yield put({ type: "SET_ROUTER_LIST", data: addressQualificationDetails?.DataInfo?.Routers });
      yield call(getFloatingCartDetails);
    } else if (params.type === 'standalone_tv') {
      yield put({ type: "SELECTED_BUNDLE_INFO_REQUEST_BODY_FOR_TV", data: infoParams })
      // yield call(fetchFiosTv, { params });
      yield put({
        type: "UPDATE_SERVICES_IN_CART",
        params: BUNDLE.VIDEO
      });
      yield call(getFloatingCartDetails);
    } else if (params.type === 'intialContract') {
      yield put({ type: "RESET_BUNDLE_CONVERSION_PROPERTIES" });
      yield put({ type: "RESET_CART_INFO_RESPONSE" });
      yield put({ type: "RESET_CART_FMONTH_PRICE" });

      // yield call(getCartInfo);
    }
  }
  else {
    try {
      if (!isLQCall) {
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
      }
      let bannerEnabledByApi = CheckAEMBoolValue(i18next.t("fios.IsBannerPreSelection",{ns:"fios"}));
      if((!bannerEnabledByApi && bannerEnabledByApi !== "IsBannerPreSelection" && bannerInfo)  || !bannerInfo){
      const response = yield apiClient.post(GET_SELECTED_BUNDLE_INFO_URL, formParams, HeadersForFormData)
      console.log(response)


      if (response?.data !== "Fail") {       

        yield put({ type: "SET_SELECTED_BUNDLE_COMPLETED", data: "Y" });
        console.log(params)
        if (params.type === 'data') {
          // const addressQualificationDetails = yield select(sel`ectors.addressQualificationDetails);
          yield put({ type: "SET_ROUTER_LIST", data: addressQualificationDetails?.DataInfo?.Routers });
          if (response?.data?.planDetails) {
            yield* processFloatingCartDetails(response.data);
          } else {
            yield call(getFloatingCartDetails);
          }
        } else if (params.type === 'standalone_tv') {
          yield put({ type: "SELECTED_BUNDLE_INFO_REQUEST_BODY_FOR_TV", data: infoParams })
          // yield call(fetchFiosTv, { params });
          yield put({
            type: "UPDATE_SERVICES_IN_CART",
            params: BUNDLE.VIDEO
          });
          if (response?.data?.planDetails) {
            yield* processFloatingCartDetails(response.data);
          } else {
            yield call(getFloatingCartDetails);
          }
        } else if (params.type === 'intialContract') {
          yield put({ type: "RESET_BUNDLE_CONVERSION_PROPERTIES" });
          yield put({ type: "RESET_CART_INFO_RESPONSE" });
          yield put({ type: "RESET_CART_FMONTH_PRICE" });

          // yield call(getCartInfo);
        }

        // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      }
      else {
        // yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "SET_SELECTED_BUNDLE_COMPLETED", data: "N" });
        yield put({ type: "FLOATING_CART_LOADING_SPINNER", data: false });
        yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_PS_GETSELECTEDBUNDLEINFO' });
      }
      yield put({ type: "GET_SELECTED_BUNDLEINFO_RESPONSE", data: response.data });
    }else if(bannerEnabledByApi && bannerEnabledByApi !== "IsBannerPreSelection" && bannerInfo){
      if (params.type === 'data') {
        const addressQualificationDetails = yield select(selectors.addressQualificationDetails);
        yield put({ type: "SET_ROUTER_LIST", data: addressQualificationDetails?.DataInfo?.Routers });
        yield call(getFloatingCartDetails);
      } else if (params.type === 'standalone_tv') {
        yield put({ type: "SELECTED_BUNDLE_INFO_REQUEST_BODY_FOR_TV", data: infoParams })
        yield put({
          type: "UPDATE_SERVICES_IN_CART",
          params: BUNDLE.VIDEO
        });
        yield call(getFloatingCartDetails);
      } else if (params.type === 'intialContract') {
        yield put({ type: "RESET_BUNDLE_CONVERSION_PROPERTIES" });
        yield put({ type: "RESET_CART_INFO_RESPONSE" });
        yield put({ type: "RESET_CART_FMONTH_PRICE" });
      }
    }
    } catch (err) {
      yield put({ type: "FLOATING_CART_LOADING_SPINNER", data: false });
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      yield put({ type: "SET_SELECTED_BUNDLE_COMPLETED", data: "N" });
      console.log('Catch Error', err);
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    }
  }


}

// used in new api
export function* getCustomizeBDVFiosBundleInfo(request) {
  // const isServiceCallAccepted = yield select(selectors.isServiceCallAccepted);
  const Is911ServiceAccepted = yield select(selectors.Is911ServiceAccepted);

  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  const lqPostData = yield select(selectors.lqPostData);

  let formParams = new URLSearchParams();
  Object.keys(request.params.FiosBdvFormData).forEach(key => {
    formParams.append(key, request.params.FiosBdvFormData[key]);
  });
  const {bdvStatus} = yield select(state=>state.CustomizeOrder.getPostLqData)
  try {
    if(bdvStatus!==null&&bdvStatus&&(bdvStatus==='Y'||bdvStatus==='y')){
    const response = yield apiClient.post(GET_SELECTED_BDV_BUNDLE_INFO_URL, formParams, HeadersForFormData)
      .then(response => {

        return response.data;
      });

    if (response && request.params.FiosBdvFormData.upselSelected == true) {
      yield put({ type: "Select_BDVBundle_ON_Internet", data: false });
      if (Is911ServiceAccepted) {
        yield put({ type: "SET_CHECKOUT_ENABLE_BDV", data: false });
      }
      else {
        yield put({ type: "SET_CHECKOUT_ENABLE_BDV", data: true });
      }
    } else if (response && request.params.FiosBdvFormData.upselSelected == false) {
      yield put({ type: "Select_BDVBundle_ON_Internet", data: true });
    }
    yield put({ type: "SET_BDV_TN_COUNT", data: 1 });
    yield put({ type: "SET_GET_BDV_TN_RESP", data: response?.TNList?.TNObject });
    yield put({ type: "GET_BDV_BUNDLE_RESPONSE", data: response });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });

    if(!!response?.TNList && !!response?.TNList?.TNObject && response?.TNList?.TNObject.length){
      let bdvSubsLines = []
      let responses= response.TNList.TNObject.length > 1 ? response.TNList.TNObject.slice(0,1):response.TNList.TNObject;
      responses.map((data,i)=>{
          bdvSubsLines.push({
              LineNO:i+1,
              OldTN:(data['TN']).replace(/-/g, ""),
              OldPlanID:data['ProductID'],
              OldIsWB:"",
              NewTN:(data['TN']).replace(/-/g, ""),
              NewPlanID:data['ProductID'],
              NewIsWB:"",
              selected:"desktop"
          })
      })
    yield put({ type: "SET_BDVW_PHONE_LINES", data: bdvSubsLines });
    }

    const customizeProductsResponse = yield select(selectors.customizeProductsResponse);
    const addressQualificationDetails = yield select(selectors.addressQualificationDetails);
    let TNObject = [];
    if (request.params?.flowType === FLOW.TRIPLE) {
      const BDVFIOSTP = JSON.parse(JSON.stringify(customizeProductsResponse?.BDVFIOSTP))
      const equipmentList = getBDVEquipments(BDVFIOSTP);
      yield put({ type: "UPDATE_BDV_EQUIPMENTS", data: equipmentList });
      TNObject = customizeProductsResponse?.BDVFIOSTP?.TNList?.TNObject;
      if (!TNObject || TNObject?.length === 0 || addressQualificationDetails?.IsCachePM === true) {
        TNObject = response?.TNList?.TNObject;
        if (TNObject && TNObject?.length !== 0) {
          yield put({
            type: "UPDATE_TN_LISTING_FROM_PROD_CALL", data: {
              key: 'BDVFIOSTP', value: {
                TNList: response?.TNList,
                FaxLineInfo: response?.FaxLineInfo,
                FaxTNList: response?.FaxTNList
              }
            }
          });
        }
      }
      yield put({ type: "SET_ROUTER_LIST", data: customizeProductsResponse?.BDVFIOSTP?.Routers });
    } else {
      const BDVFIOSDP = JSON.parse(JSON.stringify(customizeProductsResponse?.BDVFIOSDP))
      const equipmentList = getBDVEquipments(BDVFIOSDP,lqPostData.EnableBDVW);
      yield put({ type: "UPDATE_BDV_EQUIPMENTS", data: equipmentList });
      TNObject = customizeProductsResponse?.BDVFIOSDP?.TNList?.TNObject;
      if (!TNObject || TNObject?.length === 0 || addressQualificationDetails?.IsCachePM === true) {
        TNObject = response?.TNList?.TNObject;
        if (TNObject && TNObject?.length !== 0) {
          yield put({
            type: "UPDATE_TN_LISTING_FROM_PROD_CALL", data: {
              key: 'BDVFIOSDP', value: {
                TNList: response?.TNList,
                FaxLineInfo: response?.FaxLineInfo,
                FaxTNList: response?.FaxTNList
              }
            }
          });
        }
      }
      yield put({ type: "SET_ROUTER_LIST", data: customizeProductsResponse?.BDVFIOSDP?.Routers });
    }

    const tn = TNObject?.length ? TNObject[0].TN : "";
    if (!TNObject || TNObject?.length === 0) {
      yield put({ type: "BTN_EMPTY", data: true });
    }
    yield put({ type: "UPDATE_TN_FOR_LISTING", data: tn });

    if (!TNObject || TNObject?.length === 0) {
      yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_OLQ_BTNEmpty' });
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TN_FAIL } });
    }
    yield put({ type: "IS_FLOW_CHANGED", params: 'Y' });
    yield put({ type: "UPDATE_PHONE_SERVICES", params: BUNDLE.BDV });
    if (request.params?.flowType === FLOW.TRIPLE) {
      yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.BDV_DATA_VIDEO })
    } else if (request.params.FiosBdvFormData.upselSelected == true) {
      yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA });
    }
    else {
      yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA_BDV });
    }
    if (response?.planDetails) {
      yield* processFloatingCartDetails(response);
    } else {
      yield call(getFloatingCartDetails);
    }
  }
  }
  catch (err) {
    console.log('Catch Error', err);
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
  } finally {
    // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

// used in new api
export function* getCustomizeHSIPhoneBundleInfo(request) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  let formParams = new URLSearchParams();
  const LqData = yield select(selectors.LqData);
  let HSIStatus = LqData?.HSIStatus;
  Object.keys(request.params.HsiPhoneFormData).forEach(key => {
    formParams.append(key, request.params.HsiPhoneFormData[key]);
  });
  try {
    const response = yield apiClient.post(GET_SELECTED_BUNDLE_INFO_URL, formParams, HeadersForFormData)
      .then(response => {
        return response.data;
      });

    if(HSIStatus == "Y" && response?.TNList == null)
    {
      yield put({ type: "BTN_EMPTY", data: true });
      yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_OLQ_BTNEmpty' });
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TN_FAIL } });
    }
if(HSIStatus == "Y" && response?.TNList)
{
  let  TNData  = response?.TNList; 
let TNObject = TNData?.TNObject;

  let tn = TNObject?.length ?
 TNObject[0].TN : "";
 yield put({ type: "UPDATE_TN_FOR_LISTING", data: tn });
  if(TNObject?.length == 0 )
  {
    yield put({ type: "BTN_EMPTY", data: true });
    yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_OLQ_BTNEmpty' });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TN_FAIL } });
  }
  yield put({ type: "IS_Phone", data: true });
  yield put({ type: "SAVE_SELECTED_BUNDLE_TN", data: response });

}
else{
    const customizeProductsResponse = yield select(selectors.customizeProductsResponse);
    const tn = customizeProductsResponse && customizeProductsResponse?.HSIBundleInfo?.TNList?.TNObject?.length ?
      customizeProductsResponse?.HSIBundleInfo?.TNList?.TNObject[0].TN : "";
    if (customizeProductsResponse?.HSIBundleInfo?.TNList?.TNObject?.length === 0) {
      yield put({ type: "BTN_EMPTY", data: true });
    }
    yield put({ type: "UPDATE_TN_FOR_LISTING", data: tn });
    if (customizeProductsResponse?.HSIBundleInfo?.TNList?.TNObject?.length === 0) {
      yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_OLQ_BTNEmpty' });
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TN_FAIL } });
    }

  }
    yield put({ type: "IS_FLOW_CHANGED", params: 'Y' });
    yield put({ type: "UPDATE_PHONE_SERVICES", params: BUNDLE.PHONE });
    yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.HSI_PHONE });
    if (response?.planDetails) {
      yield* processFloatingCartDetails(response);
    } else {
      yield call(getFloatingCartDetails);
    }
  }

  catch (err) {
    console.log('Catch Error', err);
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}


/*********************************************                UPDATE CALLS                                  ******************************/

/** Update Standlone TV into the cart */
function* updateFiosTv(request) {
  const { allFlowRequestPayLoads, tvOrder, flowType, isFlowChanged, servicesInCart } = request.params;
  const url = UPDATE_FIOS_TV_URL;

  const oldReq = yield getRequestPayloadBasedOnBundleType({ allFlowRequestPayLoads, bundleType: UPDATEFOR.STANDALONE_VIDEO });

  // if DVR service selected, add to list of selected equipment


  let requestBody = formGenericVideoRequestBodyBasedOnFlow(tvOrder, oldReq);

  // const response = yield apiClient.post(UPDATE_FIOS_TV_URL, requestBody)
  /* Commenting Below line is for local mock json pointing */
  // const response = yield apiClient.post(url, requestBody)
  //   .then(response => {
  //     return response.data;
  //   });

  // yield put({ type: "UPDATE_FIOS_TV_SUCCESS", data: response });
  try {
    if (flowType !== FLOW.STANDALONE) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
      const response = yield apiClient.post(url, requestBody);
      if (response.data && response.data.Status && response.data.Status === "SUCCESS") {
        yield put({ type: "UPDATE_FIOS_TV_SUCCESS", data: response.data });
        if (servicesInCart === BUNDLE.VIDEO || servicesInCart === BUNDLE.FLEX) {
          yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.FLEX });
          yield put({
            type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
              id: UPDATEFOR.DOUBLE_FLEX_FIOS_VIDEO,
              selectedPlans: requestBody
            }
          });
        } else if (isFlowChanged === 'Y' && (servicesInCart === BUNDLE.DATA_PHONE || servicesInCart === BUNDLE.DATA_BDV)) {

        }
        // yield put({
        //   type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
        //     id: UPDATEFOR.STANDALONE_VIDEO,
        //     selectedPlans: requestBody
        //   }
        // });

        // yield* getCartInfo();
        yield call(getFloatingCartDetails);

        yield* loadFloatingCart();
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      }
      else {
        console.log('Catch Error');
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      }
    } else {
      if (isFlowChanged === 'N' && (servicesInCart === '' || servicesInCart === BUNDLE.VIDEO)) {
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.VIDEO });
        yield put({
          type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
            id: UPDATEFOR.STANDALONE_VIDEO,
            selectedPlans: requestBody
          }
        });
      } else if (isFlowChanged === 'Y' && (servicesInCart === BUNDLE.DATA)) {
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.FLEX });
        yield put({
          type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
            id: UPDATEFOR.DOUBLE_FLEX_FIOS_VIDEO,
            selectedPlans: requestBody
          }
        });
      }

    }
  }
  catch (e) {
    console.log('Catch Error', e);
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
  }
}

/** Update Standalone Fios Data/HSI Internet in to the cart */
function* postInternetData(request) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  let doBundle = false;
  let params = [];
  let servicesInCart = request?.params?.servicesInCart;
  // identify flow...
  let flowType = request.params.flowType;
  let allSelectedNonDoBundlePlans = request?.params?.allSelectedNonDoBundlePlans;
  let allSelectedPlans = request?.params?.allSelectedPlans;

  let selectedService = '';
  if (request.hasOwnProperty('params') && request.params.customizeOrder?.length > 0) {
    params = request.params.customizeOrder;
  }
  if (servicesInCart === BUNDLE.HSI_PHONE) {
    selectedService =
      params && params?.length > 0 && params[0].selectedDetails
        ? params[0].selectedDetails.Services[0].ServiceType
        : '';
  } else {
    selectedService =
      params && params?.length > 0 && params[0].selectedDetails
        ? params[0].selectedDetails.BundleType
        : '';
  }
  let url = "";
  let requestBody = {};

  if (flowType === FLOW.STANDALONE || flowType === FLOW.DOUBLE || flowType === FLOW.TRIPLE) {
    if (selectedService === "DSL") {
      // url = "http://localhost:3001/UpdateInternetData";
      const standaloneHSIReqParams = {
        params
      };

      requestBody = formStandaloneHSIRequestBody(standaloneHSIReqParams);
      url = UPDATE_BASIC_INTERNET_DATA_URL;
      requestBody.AddlRouterSelection = {
        "NewID": "0"
      };
      requestBody.AddlDataPlanSelection = {};
      requestBody.InstallationSelection = {
        "OldID": params[3].selectedDetails ? params[3].selectedDetails.PrdID : "",
        "NewID": params[3].selectedDetails ? params[3].selectedDetails.PrdID : ""
      };

      // if (allSelectedNonDoBundlePlans && servicesInCart === BUNDLE.HSI_PHONE) {
      //  const bundlePlan = allSelectedNonDoBundlePlans.filter(e => e.id === BUNDLE.HSI_PHONE);
      //  const planId = bundlePlan.length !== 0 && bundlePlan[0].selectedPlans.Services[0]?.ID.toString();
      // if (planId !== requestBody.DataSelection.NewID) {
      //   requestBody.DataSelection.OldID = planId;
      // } else {
      //   requestBody.DataSelection.OldID = '';
      // }
      // if (planId !== requestBody.DataPlanSelection.NewID) {
      //   requestBody.DataPlanSelection.OldID = planId;
      // } else {
      //   requestBody.DataPlanSelection.OldID = '';
      // }
      // }
      if (allSelectedPlans && (servicesInCart === BUNDLE.HSI_PHONE || servicesInCart === BUNDLE.HSI)) {
        const internet = yield select(floatSelectors.internet);
        const plan = allSelectedPlans.find(e => e.id === UPDATEFOR.STANDALONE_HSI);
        const routerName = plan?.selectedPlans?.[2]?.selectedDetails?.PrdName;
        const dbRouterId = request?.DataInfoResp?.Routers?.find(router => router.PrdName === routerName)?.PrdID;
        if (dbRouterId) {
          requestBody.RouterSelection.NewID = dbRouterId;
          internet.RouterSelection.NewID = dbRouterId;
          yield put({ type: "UPDATE_INTERNET_CART_SELECTION", data: { ...internet } });
        }
      }
    } else {
      // url = "http://localhost:3001/UpdateInternetData"
      const standaloneDataReqParams = {
        params
      };
      const oldFiosRouter = yield select(selectors.fiosRouters);
      const internetSelection = yield select(floatSelectors.internet);
      const oldFiosEquipment = oldFiosRouter.filter(
        (router) => router.IsRecomd === true && router.IsSelected === true)
        .reduce((result, router) => {
          result.PrdID = router.PrdID;
          result.PrdName = router.PrdName;
          return result;
        }, {});

      standaloneDataReqParams.params[2].oldEquipment = {
        PrdID: internetSelection?.RouterSelection?.OldID || oldFiosEquipment.PrdID,
        PrdName: oldFiosEquipment.PrdName
      };

      let requestFrom = '';
      let planSelected = {};
      if (flowType === FLOW.STANDALONE) {
        if (request.params && request.params.phoneServiceFlow && [BUNDLE.FLEX, BUNDLE.REVERSE_FLEX].indexOf(request.params.phoneServiceFlow) > -1) {
          requestFrom = BUNDLE.VIDEO;
          planSelected = request?.selectedPlanDetails;
        }
      } else if (flowType === FLOW.DOUBLE) {
        if (request.params && request.params.phoneServiceFlow && [BUNDLE.BDV_DATA, BUNDLE.DATA_BDV].indexOf(request.params.phoneServiceFlow) > -1) {
          requestFrom = BUNDLE.BDV;
          planSelected = request?.selectedPlanDetails;
        } else if (request.params && request.params.phoneServiceFlow && [BUNDLE.DATA_PHONE, BUNDLE.PHONE_DATA].indexOf(request.params.phoneServiceFlow) > -1) {
          requestFrom = BUNDLE.PHONE;
          planSelected = request?.selectedPlanDetails;
        }
      }

      requestBody = formGenericDataRequestBodyBasedOnFlow(planSelected, requestFrom, standaloneDataReqParams, flowType, servicesInCart);
      url = UPDATE_FIOS_INTERNET_DATA_URL;
      requestBody.ExtenderSelection = {
        "NewID": "0"
      };
      requestBody.BundleChoiceOffers = {};
    }

  }

  try {
    if (flowType !== FLOW.STANDALONE || request?.params?.reqFrom === "PremiumSupport" || request?.params?.reqFrom === "FlexBundle") { // allow if flow is standalone or request comes from premium support section and flex selection.
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
      const response = yield apiClient.post(url, requestBody);
      if (response.data && response.data.Status && response.data.Status === "SUCCESS") {
        if (selectedService === "DSL") {
          if (servicesInCart === BUNDLE.HSI_PHONE) {
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.DOUBLE_HSI, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.HSI_PHONE });
          } else {
            // for bundle conversion...
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.STANDALONE_HSI, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.HSI_PHONE });
          }
        } else {
          if (servicesInCart === BUNDLE.DATA_BDV) {
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.DOUBLE_DATA, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA_BDV });
          } else if (servicesInCart === BUNDLE.DATA_PHONE) {
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.DOUBLE_DATA, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA_PHONE });
          } else if (servicesInCart === BUNDLE.BDV_DATA_VIDEO) {
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.TRIPLE_DATA, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.BDV_DATA_VIDEO });
          } else if (servicesInCart === BUNDLE.PHONE_DATA_VIDEO) {
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.TRIPLE_DATA, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.PHONE_DATA_VIDEO });
          } else if (servicesInCart === BUNDLE.FLEX) {
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.DOUBLE_FLEX_FIOS_DATA, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.FLEX });
          } else {
            // for bundle conversion...
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.STANDALONE_DATA, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA });
          }
        }

        yield put({ type: "UPDATE_INTERNET_DATA_SUCCESS", data: response.data });

        // yield* getCartInfo();
        yield call(getFloatingCartDetails);

        yield* loadFloatingCart();
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      }
      // else {
      //   yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      //   console.log('Catch Error', err); yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      // }
    } else {
      // For standalone...
      if (selectedService === "DSL") {
        yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.STANDALONE_HSI, selectedPlans: requestBody } });
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.HSI });
      } else {
        yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.STANDALONE_DATA, selectedPlans: requestBody } });
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA });
      }
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
  }
  catch (e) {
    console.log('Catch Error', e);
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    // temp change for 2117 need to check with praveen whether to have updateHSI call
    //yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
  }
}

/** Update Standlone BDV/PHONE in to the cart */
function* postUpdatePhone(request) {
  const { customizeOrder, selectedIds, BDVInfoResponse, PhoneInfoResp, flowType, servicesInCart } = request.params;
  const selectedService =
    customizeOrder && customizeOrder?.length > 0 && customizeOrder[0].selectedDetails
      ? customizeOrder[0].selectedDetails.value
      : '';
  let requestBody = {};

  let phoneLines = customizeOrder[1].selectedDetails;
  /*phoneLines = phoneLines?.map(phnLine => {
    const updPhnLine = { ...phnLine };
    updPhnLine.OldTN = updPhnLine.OldTN?.replace(/-/g, "");
    updPhnLine.NewTN = updPhnLine.NewTN?.replace(/-/g, "");
    return updPhnLine;
  });*/
  let faxLines = customizeOrder[2].selectedDetails && customizeOrder[2].selectedDetails.SelectedFaxlines ? customizeOrder[2].selectedDetails.SelectedFaxlines : [];
  faxLines = faxLines.map(faxLine => {
    const updFaxLine = { ...faxLine };
    updFaxLine.OldTN = updFaxLine.OldTN ? updFaxLine.OldTN?.replace(/-/g, "") : '';
    return updFaxLine;
  });
  const dirList = customizeOrder[4].selectedDetails;
  const phnDirListing = {
    "CompanyName": dirList.CompanyName,
    "FirstName": dirList.FirstName,
    "LastName": dirList.LastName,
    "MidName": dirList.MidName,
    "Degree": dirList.Degree,
    "Designation": dirList.Designation,
    "PhoneNo": dirList.PhoneNo ? dirList.PhoneNo?.replace(/-/g, "") : "",
    "Street": dirList.Street,
    "City": dirList.City
  };

  const premiumSupportDetails = customizeOrder.premiumSupportDetails;

  let url = "";
  if (selectedService === "Business Digital Voice") {
    // url = "http://localhost:3001/updateBdv"
    url = UPDATE_BDV_URL;
    const maintanencePlan = BDVInfoResponse?.BdvMaintenance?.find(plan => plan.PrdName === "No Maintenance Plan");

    if (flowType === FLOW.STANDALONE || flowType === FLOW.TRIPLE) {
      const standaloneBDVRequestParams = {
        maintanencePlan,
        BDVInfoResponse,
        phnDirListing,
        phoneLines,
        selectedIds,
        faxLines,
        dirList,
        premiumSupportDetails
      };
    }

  } else {
    //url = "http://localhost:3001/updatePhone"
    url = UPDATE_PHONE_URL;
    phnDirListing.YellowPageHeading = dirList.YellowPageHeading;
    const maintanencePlan = PhoneInfoResp?.Maintenance?.find(plan => plan.PrdName === "No Maintenance Plan");
    const batterySelected = customizeOrder[5].selectedDetails?.value === "Yes" ? true : false;
    if (flowType === FLOW.STANDALONE || flowType === FLOW.DOUBLE || flowType === FLOW.TRIPLE) {
      const standalonePhoneRequestParams = {
        maintanencePlan,
        PhoneInfoResp,
        phnDirListing,
        phoneLines,
        dirList,
        premiumSupportDetails,
        batterySelected
      };
      requestBody = formGenericStandardPhoneRequestBody(standalonePhoneRequestParams);
    }
  }

  // try {
  //   // const response = yield apiClient.post(UPDATE_PHONE_URL, requestBody)
  //   /* Commenting Below line is for local mock json pointing */
  //   const response = yield apiClient.post(url, requestBody)
  //     .then(response => {
  //       return response.data;
  //     });
  //   put({ type: "UPDATE_PHONE_SUCCESS", data: response });
  // } catch (err) { }
  try {

    if (flowType !== FLOW.STANDALONE && flowType !== FLOW.TRIPLE) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
      const response = yield apiClient.post(url, requestBody);
      if (response.data && response.data.Status && response.data.Status === "SUCCESS") {
        put({ type: "UPDATE_PHONE_SUCCESS", data: response.data });

        if (selectedService === "Business Digital Voice") {
          if (servicesInCart === BUNDLE.BDV_DATA_VIDEO) {
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.TRIPLE_BDV, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.BDV_DATA_VIDEO });
          } else {
            // for bundle conversion...
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.STANDALONE_BDV, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.BDV });
          }
        } else {
          if (servicesInCart === BUNDLE.PHONE_DATA_VIDEO) {
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.TRIPLE_PHONE, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.PHONE_DATA_VIDEO });
          } else {
            // for bundle conversion...
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.STANDALONE_PHONE, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.PHONE });
          }
        }

        // yield* getCartInfo();
        yield call(getFloatingCartDetails);

        yield* loadFloatingCart();

        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      }
      else {
        console.log('Catch Error');
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      }
    } else {

      if (flowType === FLOW.STANDALONE) {
        if (selectedService === "Business Digital Voice") {
          // for Standalone BDV...
          yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.STANDALONE_BDV, selectedPlans: requestBody } });
          yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.BDV });
        } else {
          // for Standalone Standard Phone...
          yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.STANDALONE_PHONE, selectedPlans: requestBody } });
          yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.PHONE });
        }
      } else if (flowType == FLOW.TRIPLE) {
        if (selectedService === "Business Digital Voice") {
          if (servicesInCart === BUNDLE.BDV_DATA_VIDEO) {
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.TRIPLE_BDV, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.BDV_DATA_VIDEO });
          }
        } else {
          if (servicesInCart === BUNDLE.PHONE_DATA_VIDEO) {
            yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.TRIPLE_PHONE, selectedPlans: requestBody } });
            yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.PHONE_DATA_VIDEO });
          }
        }
      }

    }
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
  catch (e) {
    console.log('Catch Error', e);
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
  }
}

/** Update Double  DATA+BDV Bundle  */
function* postDoubleDataBDVBundle(request) {
  const {
    serviceOrder,
    customizeOrder,
    selectedIds,
    BDVInfoResponse,
    PhoneInfoResp,
    // selectedPlanDetails,
    flowType,
    servicesInCart,
    //selectedGetNonDoFlowBundlePlan,
    allFlowRequestPayLoads,
    allSelectedNonDoBundlePlans,
    DataInfoResp
  } = request.params;
  const selectedService =
    customizeOrder && customizeOrder?.length > 0 && customizeOrder[0].selectedDetails
      ? customizeOrder[0].selectedDetails.value
      : '';
  let requestBody = {};
  let phoneLines = customizeOrder[1].selectedDetails;
  phoneLines = phoneLines?.map(phnLine => {
    const updPhnLine = { ...phnLine };
    updPhnLine.OldTN = updPhnLine.OldTN?.replace(/-/g, "");
    updPhnLine.NewTN = updPhnLine.NewTN?.replace(/-/g, "");
    return updPhnLine;
  });
  let faxLines = customizeOrder[2].selectedDetails && customizeOrder[2].selectedDetails.SelectedFaxlines ? customizeOrder[2].selectedDetails.SelectedFaxlines : [];
  if (faxLines?.length > 0) {
    faxLines = faxLines.map(faxLine => {
      const updFaxLine = { ...faxLine };
      updFaxLine.OldTN = updFaxLine.OldTN ? updFaxLine.OldTN?.replace(/-/g, "") : '';
      return updFaxLine;
    });
  }

  const dirList = customizeOrder[4].selectedDetails;
  const phnDirListing = {
    "CompanyName": dirList.CompanyName,
    "FirstName": dirList.FirstName,
    "LastName": dirList.LastName,
    "MidName": dirList.MidName,
    "Degree": dirList.Degree,
    "Designation": dirList.Designation,
    "PhoneNo": dirList.PhoneNo ? dirList.PhoneNo?.replace(/-/g, "") : '',
    "Street": dirList.Street,
    "City": dirList.City
  };
  let standloneDataParam = {};
  let getStandloneDataRequestPayload = {};

  const url = POST_UPDATE_BUNDLE;
  if (request.params && request.params.reverseFlowType && request.params.reverseFlowType === REVERSE_BUNDLE.REVERSE_BDV_DATA_VIDEO) {
    // for double data...
    standloneDataParam = { allFlowRequestPayLoads, bundleType: UPDATEFOR.DOUBLE_DATA };
    getStandloneDataRequestPayload = getRequestPayloadBasedOnBundleType(standloneDataParam);
  } else {
    standloneDataParam = { allFlowRequestPayLoads, bundleType: UPDATEFOR.STANDALONE_DATA };
    getStandloneDataRequestPayload = getRequestPayloadBasedOnBundleType(standloneDataParam);
  }


  let selectedPlanDetails = {};
  if (request.params && request.params.reqFrom && request.params.reqFrom === 'GetBDVBundle') {
    selectedPlanDetails = request.params.selectedPlanDetails;
  }
  const doubleBundleNonDoPlanParams = { allSelectedNonDoBundlePlans, bundleType: BUNDLE.DATA_BDV };
  const selectedGetNonDoFlowBundleInfo = getNonDoBundlePlanBasedOnBundleType(doubleBundleNonDoPlanParams);

  if (flowType === FLOW.DOUBLE && getStandloneDataRequestPayload) {
    if (selectedService === "Business Digital Voice") {
      const maintanencePlan = BDVInfoResponse?.BdvMaintenance?.find(plan => plan.PrdName === "No Maintenance Plan");
      const doubleBDVRequestParams = {
        maintanencePlan,
        BDVInfoResponse,
        phnDirListing,
        phoneLines,
        selectedIds,
        faxLines,
        dirList
      };
      requestBody = formDoubleDataBdvRequestBody(DataInfoResp, doubleBDVRequestParams, getStandloneDataRequestPayload,
        selectedGetNonDoFlowBundleInfo, serviceOrder, selectedPlanDetails);
    }
  }

  try {
    if (flowType !== FLOW.DOUBLE || (request.params && request.params.reqFrom && request.params.reqFrom === 'GetBDVBundle')) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
      const response = yield apiClient.post(url, requestBody);
      console.log('doubleDataWithBDV url', url)
      if (response.data && response.data.Status && response.data.Status === "SUCCESS") {
        yield put({ type: "UPDATE_PHONE_SUCCESS", data: response.data });
        if (request.reverseFlowType && request.reverseFlowType === REVERSE_BUNDLE.REVERSE_BDV_DATA_VIDEO) {
          yield put({
            type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
              id: UPDATEFOR.TRIPLE_DATA + '+' + UPDATEFOR.TRIPLE_BDV,
              selectedPlans: requestBody
            }
          });
          yield put({
            type: "UPDATE_SERVICES_IN_CART",
            params: BUNDLE.BDV_DATA_VIDEO
          });
        } else {
          yield put({
            type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
              id: UPDATEFOR.DOUBLE_DATA + '+' + UPDATEFOR.DOUBLE_BDV,
              selectedPlans: requestBody
            }
          });
          yield put({
            type: "UPDATE_SERVICES_IN_CART",
            params: BUNDLE.BDV_DATA
          });
        }

        // yield* getCartInfo();
        yield call(getFloatingCartDetails);

        yield* loadFloatingCart();
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      }
      else {
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        console.log('Catch Error');
        //yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      }
    } else {
      // For double...
      yield put({
        type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
          id: UPDATEFOR.DOUBLE_DATA + '+' + UPDATEFOR.DOUBLE_BDV,
          selectedPlans: requestBody
        }
      });
      yield put({
        type: "UPDATE_SERVICES_IN_CART",
        params: BUNDLE.BDV_DATA
      });
    }
  }
  catch (e) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    console.log('Catch Error', e);
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
  }
}

/** Update  Double DATA+PHONE  Bundle  */
function* postDoubleDataPhoneBundle(request) {
  const { serviceOrder, customizeOrder, PhoneInfoResp, flowType, servicesInCart, allFlowRequestPayLoads, allSelectedNonDoBundlePlans } = request.params;
  const selectedService =
    customizeOrder && customizeOrder?.length > 0 && customizeOrder[0].selectedDetails
      ? customizeOrder[0].selectedDetails.value
      : '';
  let requestBody = {};
  let phoneLines = customizeOrder[1].selectedDetails;
  phoneLines = phoneLines.map(phnLine => {
    const updPhnLine = { ...phnLine };
    updPhnLine.OldTN = updPhnLine.OldTN?.replace(/-/g, "");
    updPhnLine.NewTN = updPhnLine.NewTN?.replace(/-/g, "");
    return updPhnLine;
  });
  let faxLines = customizeOrder[2].selectedDetails && customizeOrder[2].selectedDetails.SelectedFaxlines ? customizeOrder[2].selectedDetails.SelectedFaxlines : [];
  faxLines = faxLines.map(faxLine => {
    const updFaxLine = { ...faxLine };
    updFaxLine.OldTN = updFaxLine.OldTN ? updFaxLine.OldTN?.replace(/-/g, "") : '';
    return updFaxLine;
  });
  const dirList = customizeOrder[4].selectedDetails;
  const phnDirListing = {
    "CompanyName": dirList.CompanyName,
    "FirstName": dirList.FirstName,
    "LastName": dirList.LastName,
    "MidName": dirList.MidName,
    "Degree": dirList.Degree,
    "Designation": dirList.Designation,
    "PhoneNo": dirList.PhoneNo ? dirList.PhoneNo?.replace(/-/g, "") : "",
    "Street": dirList.Street,
    "City": dirList.City
  };


  let standloneDataParam = {};
  let getStandloneDataRequestPayload = {};

  const url = POST_UPDATE_BUNDLE;
  if (request.params && request.params.reverseFlowType &&
    request.params.reverseFlowType === REVERSE_BUNDLE.REVERSE_PHONE_DATA_VIDEO) {
    // for double data...
    standloneDataParam = { allFlowRequestPayLoads, bundleType: UPDATEFOR.DOUBLE_DATA };
    getStandloneDataRequestPayload = getRequestPayloadBasedOnBundleType(standloneDataParam);
  } else {
    standloneDataParam = { allFlowRequestPayLoads, bundleType: UPDATEFOR.STANDALONE_DATA };
    getStandloneDataRequestPayload = getRequestPayloadBasedOnBundleType(standloneDataParam);
  }

  let selectedPlanDetails;
  if (request.params && request.params.reqFrom && request.params.reqFrom === 'GetPhoneBundle') {
    selectedPlanDetails = request.params.selectedPlanDetails;
  }

  const doubleBundleNonDoPlanParams = { allSelectedNonDoBundlePlans, bundleType: BUNDLE.DATA_PHONE };
  const selectedDoubleBundleNonDoPlan = getNonDoBundlePlanBasedOnBundleType(doubleBundleNonDoPlanParams);

  if (flowType === FLOW.DOUBLE && getStandloneDataRequestPayload) {
    if (selectedService !== "Business Digital Voice") {
      phnDirListing.YellowPageHeading = dirList.YellowPageHeading;
      const maintanencePlan = PhoneInfoResp?.Maintenance?.find(plan => plan.PrdName === "No Maintenance Plan");
      const batterySelected = customizeOrder[5].selectedDetails?.value === "Yes" ? true : false;
      const doublePhoneRequestParams = {
        maintanencePlan,
        PhoneInfoResp,
        phnDirListing,
        phoneLines,
        dirList,
        batterySelected
      };
      requestBody = formDoublePhoneDATARequestBody(doublePhoneRequestParams,
        getStandloneDataRequestPayload, selectedDoubleBundleNonDoPlan, serviceOrder,
        selectedPlanDetails);
    }
  }

  try {
    if (flowType !== FLOW.DOUBLE || (request.params && request.params.reqFrom && request.params.reqFrom === 'GetPhoneBundle')) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });

      const response = yield apiClient.post(url, requestBody);

      if (response.data && response.data.Status && response.data.Status === "SUCCESS") {
        put({ type: "UPDATE_PHONE_SUCCESS", data: response.data });

        if (request.reverseFlowType && request.reverseFlowType === REVERSE_BUNDLE.REVERSE_PHONE_DATA_VIDEO) {
          yield put({
            type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
              id: UPDATEFOR.TRIPLE_DATA + '+' + UPDATEFOR.TRIPLE_PHONE,
              selectedPlans: requestBody
            }
          });
          yield put({
            type: "UPDATE_SERVICES_IN_CART",
            params: BUNDLE.PHONE_DATA_VIDEO
          });
        } else {
          yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.DOUBLE_PHONE + '+' + UPDATEFOR.DOUBLE_DATA, selectedPlans: requestBody } });
          yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA_PHONE });
        }


        // yield* getCartInfo();
        yield call(getFloatingCartDetails);

        yield* loadFloatingCart();

        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      }
      else {
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        console.log('Catch Error');
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      }
    } else {
      yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.DOUBLE_PHONE + '+' + UPDATEFOR.DOUBLE_DATA, selectedPlans: requestBody } });
      yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA_PHONE });
    }
  }
  catch (e) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    console.log('Catch Error', e);
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
  }
}

/** Update  Double HSI_INTERNET+PHONE  Bundle  */
function* postDoublePhoneHsiBundle(request) {
  const { serviceOrder, customizeOrder, PhoneInfoResp, flowType,
    servicesInCart, allFlowRequestPayLoads, allSelectedNonDoBundlePlans } = request.params;
  const selectedService =
    customizeOrder && customizeOrder?.length > 0 && customizeOrder[0].selectedDetails
      ? customizeOrder[0].selectedDetails.value
      : '';
  let requestBody = {};
  let phoneLines = customizeOrder[1].selectedDetails;
  phoneLines = phoneLines.map(phnLine => {
    const updPhnLine = { ...phnLine };
    updPhnLine.OldTN = updPhnLine.OldTN?.replace(/-/g, "");
    updPhnLine.NewTN = updPhnLine.NewTN?.replace(/-/g, "");
    return updPhnLine;
  });
  let faxLines = customizeOrder[2].selectedDetails && customizeOrder[2].selectedDetails.SelectedFaxlines ? customizeOrder[2].selectedDetails.SelectedFaxlines : [];
  faxLines = faxLines.map(faxLine => {
    const updFaxLine = { ...faxLine };
    updFaxLine.OldTN = updFaxLine.OldTN ? updFaxLine.OldTN?.replace(/-/g, "") : '';
    return updFaxLine;
  });
  const dirList = customizeOrder[4].selectedDetails;
  const phnDirListing = {
    "CompanyName": dirList.CompanyName,
    "FirstName": dirList.FirstName,
    "LastName": dirList.LastName,
    "MidName": dirList.MidName,
    "Degree": dirList.Degree,
    "Designation": dirList.Designation,
    "PhoneNo": dirList.PhoneNo ? dirList.PhoneNo?.replace(/-/g, "") : "",
    "Street": dirList.Street,
    "City": dirList.City
  };

  const url = POST_UPDATE_BUNDLE;


  const standloneDataParam = { allFlowRequestPayLoads, bundleType: UPDATEFOR.DOUBLE_HSI };
  let getStandloneDataRequestPayload = getRequestPayloadBasedOnBundleType(standloneDataParam);
  if (!getStandloneDataRequestPayload?.RouterSelection) {
    const standloneDataParamCon = { allFlowRequestPayLoads, bundleType: UPDATEFOR.STANDALONE_HSI };
    getStandloneDataRequestPayload = getRequestPayloadBasedOnBundleType(standloneDataParamCon);
  }
  const doubleBundleNonDoPlanParams = { allSelectedNonDoBundlePlans, bundleType: BUNDLE.HSI_PHONE };
  const selectedDoubleBundleNonDoPlan = getNonDoBundlePlanBasedOnBundleType(doubleBundleNonDoPlanParams);

  if (flowType === FLOW.DOUBLE && getStandloneDataRequestPayload) {
    if (selectedService !== "Business Digital Voice") {
      phnDirListing.YellowPageHeading = dirList.YellowPageHeading;
      const maintanencePlan = PhoneInfoResp?.Maintenance?.find(plan => plan.PrdName === "No Maintenance Plan");
      const doublePhoneRequestParams = {
        maintanencePlan,
        PhoneInfoResp,
        phnDirListing,
        phoneLines,
        dirList
      };
      requestBody = formDoublePhoneHSIRequestBody(doublePhoneRequestParams, getStandloneDataRequestPayload, selectedDoubleBundleNonDoPlan, serviceOrder);
    }
  }

  try {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });

    const response = yield apiClient.post(url, requestBody);

    if (response.data && response.data.Status && response.data.Status === "SUCCESS") {
      put({ type: "UPDATE_PHONE_SUCCESS", data: response.data });

      yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.DOUBLE_PHONE + '+' + UPDATEFOR.DOUBLE_DATA, selectedPlans: requestBody } });
      yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.HSI_PHONE });


      // yield* getCartInfo();
      yield call(getFloatingCartDetails);

      yield* loadFloatingCart();

      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
    else {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      console.log('Catch Error');
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    }
  }
  catch (e) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    console.log('Catch Error', e);
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
  }
}

/** Update Triple  DATA+BDV Bundle  */
function* postTripleDataBDVBundle(request) {
  const { serviceOrder, customizeOrder, selectedIds, BDVInfoResponse, PhoneInfoResp, flowType, servicesInCart,
    //selectedGetNonDoFlowBundlePlan,
    allFlowRequestPayLoads,
    allSelectedNonDoBundlePlans
  } = request.params;
  const selectedService =
    customizeOrder && customizeOrder?.length > 0 && customizeOrder[0].selectedDetails
      ? customizeOrder[0].selectedDetails.value
      : '';
  let requestBody = {};
  let phoneLines = customizeOrder[1].selectedDetails;
  phoneLines = phoneLines.map(phnLine => {
    const updPhnLine = { ...phnLine };
    updPhnLine.OldTN = updPhnLine.OldTN?.replace(/-/g, "");
    updPhnLine.NewTN = updPhnLine.NewTN?.replace(/-/g, "");
    return updPhnLine;
  });
  let faxLines = customizeOrder[2].selectedDetails && customizeOrder[2].selectedDetails.SelectedFaxlines ? customizeOrder[2].selectedDetails.SelectedFaxlines : [];
  faxLines = faxLines.map(faxLine => {
    const updFaxLine = { ...faxLine };
    updFaxLine.OldTN = updFaxLine.OldTN ? updFaxLine.OldTN?.replace(/-/g, "") : '';
    return updFaxLine;
  });
  const dirList = customizeOrder[4].selectedDetails;
  const phnDirListing = {
    "CompanyName": dirList.CompanyName,
    "FirstName": dirList.FirstName,
    "LastName": dirList.LastName,
    "MidName": dirList.MidName,
    "Degree": dirList.Degree,
    "Designation": dirList.Designation,
    "PhoneNo": dirList.PhoneNo ? dirList.PhoneNo?.replace(/-/g, "") : "",
    "Street": dirList.Street,
    "City": dirList.City
  };

  const url = POST_UPDATE_BUNDLE;
  const standloneDataParam = { allFlowRequestPayLoads, bundleType: UPDATEFOR.TRIPLE_DATA };
  const getStandloneDataRequestPayload = getRequestPayloadBasedOnBundleType(standloneDataParam);


  const doubleBundleNonDoPlanParams = { allSelectedNonDoBundlePlans, bundleType: BUNDLE.BDV_DATA_VIDEO };
  const selectedGetNonDoFlowBundleInfo = getNonDoBundlePlanBasedOnBundleType(doubleBundleNonDoPlanParams);

  if (flowType === FLOW.TRIPLE && getStandloneDataRequestPayload) {
    if (selectedService === "Business Digital Voice") {
      const maintanencePlan = BDVInfoResponse?.BdvMaintenance?.find(plan => plan.PrdName === "No Maintenance Plan");
      const doubleBDVRequestParams = {
        maintanencePlan,
        BDVInfoResponse,
        phnDirListing,
        phoneLines,
        selectedIds,
        faxLines,
        dirList
      };
      requestBody = formDoubleDataBdvRequestBody(doubleBDVRequestParams, getStandloneDataRequestPayload,
        selectedGetNonDoFlowBundleInfo, serviceOrder);

    }
  }

  try {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });

    const response = yield apiClient.post(url, requestBody);

    if (response.data && response.data.Status && response.data.Status === "SUCCESS") {
      put({ type: "UPDATE_PHONE_SUCCESS", data: response.data });

      yield put({
        type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
          id: UPDATEFOR.TRIPLE_DATA + '+' + UPDATEFOR.TRIPLE_BDV,
          selectedPlans: requestBody
        }
      });
      yield put({
        type: "UPDATE_SERVICES_IN_CART",
        params: BUNDLE.BDV_DATA_VIDEO
      });

      // yield* getCartInfo();
      yield call(getFloatingCartDetails);

      yield* loadFloatingCart();

      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
    else {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      console.log('Catch Error');
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    }
  }
  catch (e) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    console.log('Catch Error', e);
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
  }
}

/** Update  Triple DATA+PHONE  Bundle  */
function* postTripleDataPhoneBundle(request) {
  const { serviceOrder, customizeOrder, PhoneInfoResp, flowType, servicesInCart, allFlowRequestPayLoads, allSelectedNonDoBundlePlans } = request.params;
  const selectedService =
    customizeOrder && customizeOrder?.length > 0 && customizeOrder[0].selectedDetails
      ? customizeOrder[0].selectedDetails.value
      : '';
  let requestBody = {};
  let phoneLines = customizeOrder[1].selectedDetails;
  phoneLines = phoneLines.map(phnLine => {
    const updPhnLine = { ...phnLine };
    updPhnLine.OldTN = updPhnLine.OldTN?.replace(/-/g, "");
    updPhnLine.NewTN = updPhnLine.NewTN?.replace(/-/g, "");
    return updPhnLine;
  });
  let faxLines = customizeOrder[2].selectedDetails && customizeOrder[2].selectedDetails.SelectedFaxlines ? customizeOrder[2].selectedDetails.SelectedFaxlines : [];
  faxLines = faxLines.map(faxLine => {
    const updFaxLine = { ...faxLine };
    updFaxLine.OldTN = updFaxLine.OldTN ? updFaxLine.OldTN?.replace(/-/g, "") : '';
    return updFaxLine;
  });
  const dirList = customizeOrder[4].selectedDetails;
  const phnDirListing = {
    "CompanyName": dirList.CompanyName,
    "FirstName": dirList.FirstName,
    "LastName": dirList.LastName,
    "MidName": dirList.MidName,
    "Degree": dirList.Degree,
    "Designation": dirList.Designation,
    "PhoneNo": dirList.PhoneNo ? dirList.PhoneNo?.replace(/-/g, "") : "",
    "Street": dirList.Street,
    "City": dirList.City
  };

  const url = POST_UPDATE_BUNDLE;

  const standloneDataParam = { allFlowRequestPayLoads, bundleType: UPDATEFOR.TRIPLE_DATA };
  const getStandloneDataRequestPayload = getRequestPayloadBasedOnBundleType(standloneDataParam);

  const doubleBundleNonDoPlanParams = { allSelectedNonDoBundlePlans, bundleType: BUNDLE.PHONE_DATA_VIDEO };
  const selectedDoubleBundleNonDoPlan = getNonDoBundlePlanBasedOnBundleType(doubleBundleNonDoPlanParams);

  if (flowType === FLOW.TRIPLE && getStandloneDataRequestPayload) {
    if (selectedService !== "Business Digital Voice") {
      phnDirListing.YellowPageHeading = dirList.YellowPageHeading;
      const maintanencePlan = PhoneInfoResp?.Maintenance?.find(plan => plan.PrdName === "No Maintenance Plan");
      const batterySelected = customizeOrder[5].selectedDetails?.value === "Yes" ? true : false;
      const doublePhoneRequestParams = {
        maintanencePlan,
        PhoneInfoResp,
        phnDirListing,
        phoneLines,
        dirList,
        batterySelected
      };
      requestBody = formDoublePhoneDATARequestBody(doublePhoneRequestParams, getStandloneDataRequestPayload, selectedDoubleBundleNonDoPlan, serviceOrder);

    }
  }

  try {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    const response = yield apiClient.post(url, requestBody);
    if (response.data && response.data.Status && response.data.Status === "SUCCESS") {
      put({ type: "UPDATE_PHONE_SUCCESS", data: response.data });

      yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.TRIPLE_PHONE + '+' + UPDATEFOR.TRIPLE_DATA, selectedPlans: requestBody } });
      yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.PHONE_DATA_VIDEO });


      // yield* getCartInfo();
      yield call(getFloatingCartDetails);

      yield* loadFloatingCart();

      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
    else {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      console.log('Catch Error');
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    }
  }
  catch (e) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    console.log('Catch Error', e);
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
  }
}

/** Update Double Flex DATA+VIDEO Bundle  */
function* postDoubleFLEXDataVideoBundle(request) {
  const {
    serviceOrder,
    servicesInCart,
    flowType,
    allFlowRequestPayLoads,
    fiosTvResponse,
    tvOrder,
    allSelectedNonDoBundlePlans
  } = request.params;
  let requestBody = {};
  let url = POST_UPDATE_NON_BUNDLE;
  let oldTvReq = yield getRequestPayloadBasedOnBundleType({ allFlowRequestPayLoads, bundleType: UPDATEFOR.STANDALONE_VIDEO });

  if (request.params && request.params.reverseFlowType && request.params.reverseFlowType === REVERSE_BUNDLE.REVERSE_VIDEO_DATA_BDV) {
    url = POST_UPDATE_BUNDLE;
    oldTvReq = yield getRequestPayloadBasedOnBundleType({ allFlowRequestPayLoads, bundleType: UPDATEFOR.DOUBLE_VIDEO });

  } else if (request.params && request.params.reverseFlowType && request.params.reverseFlowType === REVERSE_BUNDLE.REVERSE_VIDEO_DATA_PHONE) {
    url = POST_UPDATE_BUNDLE;
    oldTvReq = yield getRequestPayloadBasedOnBundleType({ allFlowRequestPayLoads, bundleType: UPDATEFOR.DOUBLE_VIDEO });
  }

  const equipmentList = tvOrder[4]?.selectedDetails?.value && tvOrder[4]?.selectedDetails?.value !== '000'
    ? tvOrder[3].selectedDetails.value?.concat(tvOrder[4].selectedDetails.value)
    : tvOrder[3].selectedDetails.value;

  let recordingList = tvOrder[4].selectedDetails;
  let channelList = {
    internationalSelection: tvOrder[2].selectedDetails.internationalSelection,
    movieSelection: tvOrder[2].selectedDetails.movieSelection,
    specialtySelection: tvOrder[2].selectedDetails.specialtySelection,
    sportsSelection: tvOrder[2].selectedDetails.sportsSelection,
  };
  let routerList = tvOrder[5];
  let PlanSelection = tvOrder[1].selectedDetails;
  let ViewSelection = tvOrder[0].selectedDetails;

  // triple update...
  let selectedPlanDetails = {};
  let standloneDataParam = {};
  let getStandloneDataRequestPayload = {};
  let isReverseFlow = false;
  if (request.params && request.params.reqFrom && request.params.reqFrom === 'GetBDVBundle') {
    selectedPlanDetails = request.params.selectedPlanDetails;
    isReverseFlow = true;
  } else {
    standloneDataParam = { allFlowRequestPayLoads, bundleType: UPDATEFOR.STANDALONE_DATA };
    getStandloneDataRequestPayload = getRequestPayloadBasedOnBundleType(standloneDataParam);
  }

  const standloneDataSelectedBundleInfoParam = { selectedGetNonDoFlowBundlePlan: allSelectedNonDoBundlePlans, bundleType: BUNDLE.FLEX };
  const selectedGetNonDoFlowBundleInfo = getSelectedBundleInfoBasedOnBundleType(standloneDataSelectedBundleInfoParam);

  if ((flowType === FLOW.DOUBLE && getStandloneDataRequestPayload) || (request.params.reqFrom && request.params.reqFrom === 'GetPhoneBundle' || request.params.reqFrom && request.params.reqFrom === 'GetBDVBundle')) {
    const doubleTVRequestParams = {
      fiosTvResponse,
      equipmentList,
      recordingList,
      channelList,
      routerList,
      ViewSelection,
      PlanSelection,
      tvOrder,
      oldTvReq,
    };
    requestBody = formDoubleFlexDataVideoRequestBody(doubleTVRequestParams, getStandloneDataRequestPayload,
      selectedGetNonDoFlowBundleInfo, serviceOrder, isReverseFlow, selectedPlanDetails);
  }
  if (flowType !== FLOW.DOUBLE) {
    try {

      yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
      const response = yield apiClient.post(url, requestBody);
      if (response.data && response.data.Status && response.data.Status === "SUCCESS") {
        put({ type: "UPDATE_FIOS_TV_SUCCESS", data: response.data });

        yield put({
          type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
            id: UPDATEFOR.DOUBLE_DATA + UPDATEFOR.DOUBLE_VIDEO,
            selectedPlans: requestBody
          }
        });
        yield put({
          type: "UPDATE_SERVICES_IN_CART",
          params: BUNDLE.FLEX
        });


        // yield* getCartInfo();
        yield call(getFloatingCartDetails);

        yield* loadFloatingCart();

        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      }
      else {
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        console.log('Catch Error');
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      }
    }
    catch (e) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      console.log('Catch Error', e);
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    }
  } else {
    yield put({
      type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
        id: UPDATEFOR.DOUBLE_DATA + UPDATEFOR.DOUBLE_VIDEO,
        selectedPlans: requestBody
      }
    });
    yield put({
      type: "UPDATE_SERVICES_IN_CART",
      params: BUNDLE.FLEX
    });
  }
}



/** Update Triple  BDV+DATA+VIDEO Bundle  */
function* postTripleBDVBundle(request) {
  const { serviceOrder, customizeOrder, selectedIds, BDVInfoResponse, PhoneInfoResp, flowType, servicesInCart,
    //selectedGetNonDoFlowBundlePlan,
    allFlowRequestPayLoads,
    allSelectedNonDoBundlePlans, tvOrder, fiosTvResponse, isBundleOffersFlow
  } = request.params;
  const selectedService =
    customizeOrder && customizeOrder?.length > 0 && customizeOrder[0].selectedDetails
      ? customizeOrder[0].selectedDetails.value
      : '';
  let requestBody = {};
  let phoneLines = customizeOrder[1].selectedDetails;
  phoneLines = phoneLines.map(phnLine => {
    const updPhnLine = { ...phnLine };
    updPhnLine.OldTN = updPhnLine.OldTN?.replace(/-/g, "");
    updPhnLine.NewTN = updPhnLine.NewTN?.replace(/-/g, "");
    return updPhnLine;
  });
  let faxLines = customizeOrder[2].selectedDetails && customizeOrder[2].selectedDetails.SelectedFaxlines ? customizeOrder[2].selectedDetails.SelectedFaxlines : [];
  faxLines = faxLines.map(faxLine => {
    const updFaxLine = { ...faxLine };
    updFaxLine.OldTN = updFaxLine.OldTN ? updFaxLine.OldTN?.replace(/-/g, "") : '';
    return updFaxLine;
  });
  const dirList = customizeOrder[4].selectedDetails;
  const phnDirListing = {
    "CompanyName": dirList.CompanyName,
    "FirstName": dirList.FirstName,
    "LastName": dirList.LastName,
    "MidName": dirList.MidName,
    "Degree": dirList.Degree,
    "Designation": dirList.Designation,
    "PhoneNo": dirList.PhoneNo ? dirList.PhoneNo?.replace(/-/g, "") : "",
    "Street": dirList.Street,
    "City": dirList.City
  };

  const equipmentList = tvOrder[4]?.selectedDetails?.value && tvOrder[4]?.selectedDetails?.value !== '000'
    ? tvOrder[3].selectedDetails.value?.concat(tvOrder[4].selectedDetails.value)
    : tvOrder[3].selectedDetails.value;

  let recordingList = tvOrder[4].selectedDetails;
  let channelList = {
    internationalSelection: tvOrder[2].selectedDetails.internationalSelection,
    movieSelection: tvOrder[2].selectedDetails.movieSelection,
    specialtySelection: tvOrder[2].selectedDetails.specialtySelection,
    sportsSelection: tvOrder[2].selectedDetails.sportsSelection,
  };
  let routerList = tvOrder[5];
  let PlanSelection = tvOrder[1].selectedDetails;
  let ViewSelection = tvOrder[0].selectedDetails;
  let bundleType = '';

  const url = POST_UPDATE_BUNDLE;
  if (isBundleOffersFlow === 'Y') {
    bundleType = UPDATEFOR.TRIPLE_DATA;
  } else {
    bundleType = UPDATEFOR.STANDALONE_DATA;
  }
  const standloneDataParam = { allFlowRequestPayLoads, bundleType: bundleType };
  const getStandloneDataRequestPayload = getRequestPayloadBasedOnBundleType(standloneDataParam);


  const doubleBundleNonDoPlanParams = { allSelectedNonDoBundlePlans, bundleType: BUNDLE.BDV_DATA_VIDEO };
  const selectedGetNonDoFlowBundleInfo = getNonDoBundlePlanBasedOnBundleType(doubleBundleNonDoPlanParams);

  if (flowType === FLOW.TRIPLE && getStandloneDataRequestPayload) {
    if (selectedService === "Business Digital Voice") {
      const maintanencePlan = BDVInfoResponse?.BdvMaintenance?.find(plan => plan.PrdName === "No Maintenance Plan");
      const doubleBDVRequestParams = {
        maintanencePlan,
        BDVInfoResponse,
        phnDirListing,
        phoneLines,
        selectedIds,
        faxLines,
        dirList
      };
      const tripleTVRequestParams = {
        fiosTvResponse,
        equipmentList,
        recordingList,
        channelList,
        routerList,
        ViewSelection,
        PlanSelection,
        tvOrder
      };

      // change the object... for standlone when coming from bundle offer or banner flow for triple...
      requestBody = formTripleDataBdvTvRequestBody(doubleBDVRequestParams, getStandloneDataRequestPayload,
        selectedGetNonDoFlowBundleInfo, serviceOrder, tripleTVRequestParams);

    }
  }


  if (flowType !== FLOW.TRIPLE) {
    try {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
      // const req = {"voiceModelPost":{"PhoneLines":[{"LineNO":1,"OldTN":"2129270859","OldPlanID":"2033073","OldIsWB":"","NewTN":"2129270859","NewPlanID":"2033073","NewLDProvider":"","NewLDPlan":"","NewIsWB":""}],"CallingFeat":{},"BundleSelection":{"OldID":"510002345","NewID":"510002345"},"Maintenance":{"OldID":"305","NewID":"305"},"Jacks":[{"PrdID":"101","CountInCart":"0"},{"PrdID":"100","CountInCart":"0"}],"DirListing":{"NewID":"602"},"ListingInfo":{"CompanyName":"","FirstName":"","LastName":"","MidName":"","Degree":"","Designation":"","YellowPageHeading":"","PhoneNo":"2129270859","Street":"3  ITO MAR ST ","City":"MANHATTAN"},"addedbuttonSelectionphon":{"addedbutton":"PHN:phnplanlblrequired=Added,backuplblrequired=Added,dirlistlblrequired=Added,accordionsubheaderdivphnplan=\n\n                                                                                         Pick your Phone services\n                                                                                ,accordionsubheaderdivpowerbackup=     Voice Backup PowerReserve Declined,accordionsubheaderdivdirlist=     Non Published & Non Listed"},"GlobalValues":[{"key":"IsBundle","value":"Y"},{"key":"IsWinback","value":"N"}]},"fiOSDataModelPost":{"DataSelection":{"OldID":"510002345","NewID":"510002345"},"DataPlanSelection":{"OldID":"25568266","NewID":"25568266"},"RouterSelection":{"OldID":"24541273","NewID":"24541273"},"ExtenderSelection":{"NewID":"0"},"BundleChoiceOffers":{},"SelectedVASPlans":[{"PkgID":"","PPPID":"0"}],"SelectedPPS":[{"PrdCat":"VAS","PkgID":"56578263","PPPID":"7486988"}],"addedbuttonSelection":{"addedbutton":"INR:inrlblrequired=Added,addlblrequired=Added,prmlblrequired=Added,eqmlblrequired=Added,accordionsubheaderdivinr=                     Fios Internet 400M/400M - 2YR                              ,accordionsubheaderdivprm=     Tech Support Pro,accordionsubheaderdivequ=     Purchase Fios Quantum Gateway Router,accordionsubheaderdivadd=     I do not need a Security Bundle"}},"FiOSTVModelPost":{"PlanSelection":{"OldID":"25511754","NewID":"25389833"},"ViewSelection":{"NewID":"PRIVATE"},"CustomCHSelection":[],"RecordShow":false,"TOSAccepted":true,"SelectedEquipments":["25562327"],"MovieSelection":[],"SportsSelection":[],"SpecialitySelection":[],"InternationalSelection":[],"TOSDone":true,"QNDone":false,"PeopleCount":"","SatelliteOrDish":"NA","SelectedPPS":[{"PrdCat":"VAS","PkgID":"56578263","PPPID":"7486988"}],"addedbuttonSelectionTV":{"addedbutton":"TV:lblrequiredtvoption=Added,lblrequiredtvplan=Added,lblrequiredselecttvequ=Added,lblrequiredgateway=Required,lblrequiredtvprmsupport=Required,lblrequiredtvchennels=Optional,accordionsubheaderdivtvoption=     \n                                                                                    Private View\n                                                                                    \n                                                                                ,accordionsubheaderdivtvplan=     Fios Current TV - Private,accordionsubheaderdivtvequ=      Fios TV Equipment,accordionsubheaderdivgateway=      Fios Quantum Gateway,accordionsubheaderdivtvpremsupport=      Maintenance and Support Services","continuebuttonvaidation":"optRecordNo"}}};
      const response = yield apiClient.post(url, requestBody);

      if (response.data && response.data.Status && response.data.Status === "SUCCESS") {
        put({ type: "UPDATE_PHONE_SUCCESS", data: response.data });

        yield put({
          type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
            id: UPDATEFOR.TRIPLE_DATA + '+' + UPDATEFOR.TRIPLE_BDV + '+' + UPDATEFOR.TRIPLE_VIDEO,
            selectedPlans: requestBody
          }
        });
        yield put({
          type: "UPDATE_SERVICES_IN_CART",
          params: BUNDLE.BDV_DATA_VIDEO
        });


        // yield* getCartInfo();
        yield call(getFloatingCartDetails);

        yield* loadFloatingCart();

        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      }
      else {
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        console.log('Catch Error');
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      }
    }
    catch (e) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      console.log('Catch Error', e);
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    }
  } else {
    yield put({
      type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: {
        id: UPDATEFOR.TRIPLE_DATA + '+' + UPDATEFOR.TRIPLE_BDV + '+' + UPDATEFOR.TRIPLE_VIDEO,
        selectedPlans: requestBody
      }
    });
    yield put({
      type: "UPDATE_SERVICES_IN_CART",
      params: BUNDLE.BDV_DATA_VIDEO
    });
  }

}

/** Update Triple  PHONE+DATA+VIDEO Bundle  */
function* postTripleSolutionBundleFios(request) {
  const { serviceOrder, customizeOrder, PhoneInfoResp, flowType, servicesInCart, allFlowRequestPayLoads, allSelectedNonDoBundlePlans, tvOrder, fiosTvResponse } = request.params;
  const selectedService =
    customizeOrder && customizeOrder?.length > 0 && customizeOrder[0].selectedDetails
      ? customizeOrder[0].selectedDetails.value
      : '';
  let requestBody = {};
  let phoneLines = customizeOrder[1].selectedDetails;
  phoneLines = phoneLines.map(phnLine => {
    const updPhnLine = { ...phnLine };
    updPhnLine.OldTN = updPhnLine.OldTN?.replace(/-/g, "");
    updPhnLine.NewTN = updPhnLine.NewTN?.replace(/-/g, "");
    return updPhnLine;
  });
  let faxLines = customizeOrder[2].selectedDetails && customizeOrder[2].selectedDetails.SelectedFaxlines ? customizeOrder[2].selectedDetails.SelectedFaxlines : [];
  faxLines = faxLines.map(faxLine => {
    const updFaxLine = { ...faxLine };
    updFaxLine.OldTN = updFaxLine.OldTN ? updFaxLine.OldTN?.replace(/-/g, "") : '';
    return updFaxLine;
  });
  const dirList = customizeOrder[4].selectedDetails;
  const phnDirListing = {
    "CompanyName": dirList.CompanyName,
    "FirstName": dirList.FirstName,
    "LastName": dirList.LastName,
    "MidName": dirList.MidName,
    "Degree": dirList.Degree,
    "Designation": dirList.Designation,
    "PhoneNo": dirList.PhoneNo ? dirList.PhoneNo?.replace(/-/g, "") : "",
    "Street": dirList.Street,
    "City": dirList.City
  };

  const url = POST_UPDATE_BUNDLE;

  const equipmentList = tvOrder[4]?.selectedDetails?.value && tvOrder[4]?.selectedDetails?.value !== '000'
    ? tvOrder[3].selectedDetails.value?.concat(tvOrder[4].selectedDetails.value)
    : tvOrder[3].selectedDetails.value;

  let recordingList = tvOrder[4].selectedDetails;
  let channelList = {
    internationalSelection: tvOrder[2].selectedDetails.internationalSelection,
    movieSelection: tvOrder[2].selectedDetails.movieSelection,
    specialtySelection: tvOrder[2].selectedDetails.specialtySelection,
    sportsSelection: tvOrder[2].selectedDetails.sportsSelection,
  };
  let routerList = tvOrder[5];
  let PlanSelection = tvOrder[1].selectedDetails;
  let ViewSelection = tvOrder[0].selectedDetails;

  const standloneDataParam = { allFlowRequestPayLoads, bundleType: UPDATEFOR.STANDALONE_DATA };
  const getStandloneDataRequestPayload = getRequestPayloadBasedOnBundleType(standloneDataParam);

  const doubleBundleNonDoPlanParams = { allSelectedNonDoBundlePlans, bundleType: BUNDLE.PHONE_DATA_VIDEO };
  const selectedDoubleBundleNonDoPlan = getNonDoBundlePlanBasedOnBundleType(doubleBundleNonDoPlanParams);

  if (flowType === FLOW.TRIPLE && getStandloneDataRequestPayload) {
    if (selectedService !== "Business Digital Voice") {
      phnDirListing.YellowPageHeading = dirList.YellowPageHeading;
      const maintanencePlan = PhoneInfoResp?.Maintenance?.find(plan => plan.PrdName === "No Maintenance Plan");
      const doublePhoneRequestParams = {
        maintanencePlan,
        PhoneInfoResp,
        phnDirListing,
        phoneLines,
        dirList
      };
      const tripleTVRequestParams = {
        fiosTvResponse,
        equipmentList,
        recordingList,
        channelList,
        routerList,
        ViewSelection,
        PlanSelection,
        tvOrder
      };
      requestBody = formTripleSolutionBundleFiosRequestBody(doublePhoneRequestParams, getStandloneDataRequestPayload, selectedDoubleBundleNonDoPlan, serviceOrder, tripleTVRequestParams);
    }
  }

  if (flowType !== FLOW.TRIPLE) {
    try {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
      // const req = {"voiceModelPost":{"PhoneLines":[{"LineNO":1,"OldTN":"2129270859","OldPlanID":"2033073","OldIsWB":"","NewTN":"2129270859","NewPlanID":"2033073","NewLDProvider":"","NewLDPlan":"","NewIsWB":""}],"CallingFeat":{},"BundleSelection":{"OldID":"510002345","NewID":"510002345"},"Maintenance":{"OldID":"305","NewID":"305"},"Jacks":[{"PrdID":"101","CountInCart":"0"},{"PrdID":"100","CountInCart":"0"}],"DirListing":{"NewID":"602"},"ListingInfo":{"CompanyName":"","FirstName":"","LastName":"","MidName":"","Degree":"","Designation":"","YellowPageHeading":"","PhoneNo":"2129270859","Street":"3  ITO MAR ST ","City":"MANHATTAN"},"addedbuttonSelectionphon":{"addedbutton":"PHN:phnplanlblrequired=Added,backuplblrequired=Added,dirlistlblrequired=Added,accordionsubheaderdivphnplan=\n\n                                                                                         Pick your Phone services\n                                                                                ,accordionsubheaderdivpowerbackup=     Voice Backup PowerReserve Declined,accordionsubheaderdivdirlist=     Non Published & Non Listed"},"GlobalValues":[{"key":"IsBundle","value":"Y"},{"key":"IsWinback","value":"N"}]},"fiOSDataModelPost":{"DataSelection":{"OldID":"510002345","NewID":"510002345"},"DataPlanSelection":{"OldID":"25568266","NewID":"25568266"},"RouterSelection":{"OldID":"24541273","NewID":"24541273"},"ExtenderSelection":{"NewID":"0"},"BundleChoiceOffers":{},"SelectedVASPlans":[{"PkgID":"","PPPID":"0"}],"SelectedPPS":[{"PrdCat":"VAS","PkgID":"56578263","PPPID":"7486988"}],"addedbuttonSelection":{"addedbutton":"INR:inrlblrequired=Added,addlblrequired=Added,prmlblrequired=Added,eqmlblrequired=Added,accordionsubheaderdivinr=                     Fios Internet 400M/400M - 2YR                              ,accordionsubheaderdivprm=     Tech Support Pro,accordionsubheaderdivequ=     Purchase Fios Quantum Gateway Router,accordionsubheaderdivadd=     I do not need a Security Bundle"}},"FiOSTVModelPost":{"PlanSelection":{"OldID":"25511754","NewID":"25389833"},"ViewSelection":{"NewID":"PRIVATE"},"CustomCHSelection":[],"RecordShow":false,"TOSAccepted":true,"SelectedEquipments":["25562327"],"MovieSelection":[],"SportsSelection":[],"SpecialitySelection":[],"InternationalSelection":[],"TOSDone":true,"QNDone":false,"PeopleCount":"","SatelliteOrDish":"NA","SelectedPPS":[{"PrdCat":"VAS","PkgID":"56578263","PPPID":"7486988"}],"addedbuttonSelectionTV":{"addedbutton":"TV:lblrequiredtvoption=Added,lblrequiredtvplan=Added,lblrequiredselecttvequ=Added,lblrequiredgateway=Required,lblrequiredtvprmsupport=Required,lblrequiredtvchennels=Optional,accordionsubheaderdivtvoption=     \n                                                                                    Private View\n                                                                                    \n                                                                                ,accordionsubheaderdivtvplan=     Fios Current TV - Private,accordionsubheaderdivtvequ=      Fios TV Equipment,accordionsubheaderdivgateway=      Fios Quantum Gateway,accordionsubheaderdivtvpremsupport=      Maintenance and Support Services","continuebuttonvaidation":"optRecordNo"}}};
      const response = yield apiClient.post(url, requestBody);

      if (response.data && response.data.Status && response.data.Status === "SUCCESS") {
        put({ type: "UPDATE_PHONE_SUCCESS", data: response.data });
        yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.TRIPLE_DATA + '+' + UPDATEFOR.TRIPLE_PHONE + '+' + UPDATEFOR.TRIPLE_VIDEO, selectedPlans: requestBody } });
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.PHONE_DATA_VIDEO });


        // yield* getCartInfo();
        yield call(getFloatingCartDetails);

        yield* loadFloatingCart();

        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      }
      else {
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        console.log('Catch Error');
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      }
    }
    catch (e) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      console.log('Catch Error', e);
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
      yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    }
  } else {
    yield put({ type: "SET_ALL_FLOW_REQUEST_PAYLOADS", params: { id: UPDATEFOR.TRIPLE_DATA + '+' + UPDATEFOR.TRIPLE_PHONE + '+' + UPDATEFOR.TRIPLE_VIDEO, selectedPlans: requestBody } });
    yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.PHONE_DATA_VIDEO });
  }

}

export function* getFlexSelection(params) {
  const formParams = new URLSearchParams();

  Object.keys(params.data.flexFormData).forEach(key => {
    formParams.append(key, params.data.flexFormData[key]);
  });

  try {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    const response = yield apiClient.post(GET_SELECTED_FLEX_BUNDLE_INFO_URL, formParams, HeadersForFormData);
    console.log(response);
    yield put({ type: "UPDATE_ALL_SELECTED_NON_DO_BUNDLE_PLANS_INFO", params: { id: BUNDLE.FLEX, selectedPlans: formParams } });
    // yield put({ type: "SET_SELECTED_NON_DO_BUNDLE_PLANS", params: { id: BUNDLE.FLEX, selectedPlans: newSelection[0] } });
    yield put({
      type: "UPDATE_SERVICES_IN_CART",
      params: BUNDLE.FLEX
    });
    if (response?.data?.planDetails) {
      yield* processFloatingCartDetails(response.data);
    } else {
      yield call(getFloatingCartDetails);
    }
  } catch (err) {
    console.log('Catch Error', err);
    yield put({ type: "FLOATING_CART_LOADING_SPINNER", data: false });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "SET_SELECTED_BUNDLE_COMPLETED", data: "N" });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
  }
}

/*********************************************              DO BUNDLE CONVERSION SAGA ACTION WATCHER       *******************************/
export function* bundleCoversionActionWatcher() {
  yield takeLatest('TEST_MULTI_SAGA', getTestSaga);
  yield takeLatest('GET_SELECTED_BUNDLE_INFO', getSelectedBundleInfo);
  yield takeLatest('GET_FIOS_TV_REQUEST', fetchFiosTv);
  yield takeLatest('GET_FLOAT_CART', getFloatingCartDetails);

  // standalone play
  yield takeLatest('POST_INTERNET_DATA', postInternetData);
  yield takeLatest('UPDATE_PHONE', postUpdatePhone);
  yield takeLatest('UPDATE_FIOS_TV', updateFiosTv);

  // double play
  yield takeLatest('POST_DOUBLE_DATA_BDV_REQUEST', postDoubleDataBDVBundle);
  yield takeLatest('POST_DOUBLE_DATA_PHONE_REQUEST', postDoubleDataPhoneBundle);
  yield takeLatest('POST_DOUBLE_DATA_TV_REQUEST', postDoubleFLEXDataVideoBundle);
  yield takeLatest('POST_DOUBLE_HSI_PHONE_REQUEST', postDoublePhoneHsiBundle);
  yield takeLatest('GET_CUSTOMIZE_FIOS_BDV_REQUEST', getCustomizeBDVFiosBundleInfo);
  yield takeLatest('GET_CUSTOMIZE_HSI_PHONE_REQUEST', getCustomizeHSIPhoneBundleInfo);
  yield takeLatest('GET_FLEX_SELECTION', getFlexSelection);

  // triple play
  yield takeLatest('POST_TRIPLE_DATA_BDV_REQUEST', postTripleDataBDVBundle);
  yield takeLatest('POST_TRIPLE_DATA_PHONE_REQUEST', postTripleDataPhoneBundle);
  yield takeLatest('POST_TRIPLE_DATA_BDV_TV_REQUEST', postTripleBDVBundle);
  yield takeLatest('POST_TRIPLE_DATA_PHONE_TV_REQUEST', postTripleSolutionBundleFios);

}
